import axiosInstance from "app/axiosInstance";

export interface ShouldShowReminderResponse {
  shouldShow: boolean;
  lastDismissedAt?: string;
  lastDownloadedAt?: string;
}

export interface DismissReminderResponse {
  success: boolean;
  dismissedAt: string;
}

class TripBackupReminderService {
  /**
   * Check if the backup reminder should be shown for the user
   * The API can return either a boolean or an object with shouldShow property
   */
  static shouldShowReminder = async (
    accountId: string
  ): Promise<ShouldShowReminderResponse | boolean> => {
    try {
      const response = await axiosInstance.get<
        ShouldShowReminderResponse | boolean
      >(`/accounts/${accountId}/users/me/backup-reminder/should-show`);
      return response.data;
    } catch (error) {
      console.error("Failed to check if reminder should show:", error);
      throw error;
    }
  };

  /**
   * Dismiss the backup reminder
   */
  static dismissReminder = async (
    accountId: string
  ): Promise<DismissReminderResponse> => {
    try {
      const response = await axiosInstance.post<DismissReminderResponse>(
        `/accounts/${accountId}/users/me/backup-reminder/dismiss`
      );
      return response.data;
    } catch (error) {
      console.error("Failed to dismiss reminder:", error);
      throw error;
    }
  };
}

export default TripBackupReminderService;
